// extracted by css-extract-rspack-plugin
export default {"content-root":"WaaH77","contentRoot":"WaaH77","title":"x_VANo","message":"VWwS0H","image":"xLkYAf"};